import * as analytic from '@anm/analytic';
import CopyLink from '@anm/components/CopyLink';
import { useCallback, FC } from 'react';

import { EmbedData } from '../../../../../../store/modules/hostedVideo';
import { SectionSubTitle } from '../../../Wrapper';

import { Wrapper } from './Wrapper';

type SnippetWithCopyProps = {
  embedData: EmbedData;
  isEmbedded: boolean;
  formattedSnippet: string;
};

const SnippetWithCopy: FC<SnippetWithCopyProps> = ({ embedData, isEmbedded, formattedSnippet }) => {
  const handleEmbedCodeCopy = useCallback(analytic.trackCopyEmbedCode, []);

  const key = `${embedData.type}/${embedData.sizes.width}/${embedData.sizes.height}/${embedData.popover?.popoverType}/${embedData.sizeType}`;

  return (
    <Wrapper>
      <SectionSubTitle title="Embed code" level={4} />
      <CopyLink
        autoResize
        key={key}
        link={formattedSnippet}
        direction="vertical"
        multirows={true}
        disabled={!isEmbedded}
        buttonSize="medium"
        buttonText="Copy code"
        inputVariant="disabled_gray"
        buttonVariant="white-blue-border-hosting"
        onCopy={handleEmbedCodeCopy}
      />
    </Wrapper>
  );
};

export default SnippetWithCopy;
